import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Course, Section, SectionUpdatePayload, Location } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { LanguageSelectorComponent } from '../../../ui/language-selector/language-selector.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LocationFieldComponent } from '../../../fields/standard/location-field/location-field.component';
import { AdminService } from '../../../../services/admin.service';

@Component({
	selector: 'app-section-form',
	imports: [AngularModule, ZorroModule, LanguageSelectorComponent, LocationFieldComponent],
	templateUrl: './section-form.html',
	styleUrl: './section-form.scss',
})
export class SectionForm {
	@Input('course') public course: Course | undefined;
	@Input('editSection') public editSection: Section | undefined;
	@Output('onSave') public onSave: EventEmitter<SectionUpdatePayload> = new EventEmitter();
	@Output('onClear') public onClear: EventEmitter<void> = new EventEmitter();

	public availableLocations: Location[] = [];

	public form!: FormGroup;

	constructor(
		private fb: FormBuilder,
		public adminService: AdminService
	) {
		this.form = this.fb.group({
			name: [null, []],
			locationUuid: [null, []],
			language: ['en', []],
			activeStartDate: [null, []],
			activeEndDate: [null, []],
			active: [true, []],
			allowSelfRostering: [false, []],
			isDemo: [false, []],
			ssoSectionId: [null, []],
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['editSection'] && changes['editSection'].currentValue) {
			const section: Section = changes['editSection'].currentValue;

			this.form.patchValue({
				name: section.name || null,
				locationUuid: section.location_uuid || null,
				language: section.language || null,
				activeStartDate: section.active_start_date ? new Date(section.active_start_date) : null,
				activeEndDate: section.active_end_date ? new Date(section.active_end_date) : null,
				active: section.active,
				allowSelfRostering: section.allow_self_rostering,
				isDemo: section.is_demo,
				ssoSectionId: section.sso_section_id || null,
			});
		}
	}

	public onLanguageChange(language: string): void {
		this.form.patchValue({ language: language });
	}

	public onLocationChange(locationUuid: string): void {
		if (!this.editSection) {
			throw new Error('No section selected!');
		}
		this.editSection.location_uuid = locationUuid;
	}

	public save(): void {
		if (!this.editSection) {
			throw new Error('No section selected!');
		}

		const payload: SectionUpdatePayload = {
			name: this.form.value.name || this.editSection.name,
			language: this.form.value.language || this.editSection.language,
			location_uuid: this.form.value.locationUuid || this.editSection.location_uuid,
			active: this.form.value.active || this.editSection.active,
			allow_self_rostering: this.form.value.allowSelfRostering || this.editSection.allow_self_rostering,
			is_demo: this.form.value.isDemo || this.editSection.is_demo,
			active_start_date: this.form.value.activeStartDate || this.editSection.active_start_date,
			active_end_date: this.form.value.activeEndDate || this.editSection.active_end_date,
			sso_section_id: this.form.value.ssoSectionId || this.editSection.sso_section_id,
		};

		this.onSave.emit(payload);
	}

	public clear(): void {
		this.onClear.emit();
	}
}
